import Params from "./Params";
import axios from "axios";
import {isElement, normalizeData, find, execute} from "../../../../../modules/vegas/js/util";

class Request extends Params {
	constructor(element, params = {}) {
		super();

		this._element = null;
		this.element = element;
		this.params = this.getParams(params, this.element);
	}

	set element(el) {
		function getElm(el) {
			if (!el) {
				throw new Error('Товарищ! Первый параметр не должен быть пустым!');
			} else {
				if (typeof el === 'string') {
					let elm = document.getElementById(el);
					if (elm) return elm;
					else throw new Error('Ахпер! Не удалось найти элемент');
				} else if (isElement(el)) {
					return el;
				} else {
					throw new Error('КЭП! Какая-то дичь к нам залетела');
				}
			}
		}

		this._element = getElm(el);
	}

	get element() {
		return this._element;
	}

	run(callback) {
		const _this = this;

		return axios.get(_this.params.points.get, {
			params: {
				view: _this.params.view,
				company: _this.params.company,
				point: _this.params.point,
				servicing_offices: _this.params.servicing_offices,
			}
		}).then(function (response) {
			execute(callback, [
				_this.getPoints(normalizeData(response.data)),
				normalizeData(response.data)
			]);
		});
	}

	static setPoint(route, data, callback) {
		axios.post(route, data).then(function (response) {
			execute(callback.success, [normalizeData(response.data)]);
		}).catch(function (error) {
			execute(callback.error, [normalizeData(error)]);
		});
	}

	getPoints(data) {
		const _this = this;
		let points = [];

		if (_this.params.company) {
			const company = _this.params.company === 'stores' ? 'pickup' : _this.params.company;
			data = data.filter(function (item) {
				return item.name === company;
			})
		}

		data.forEach(function (datum) {
			datum.points.forEach(function (point) {
				point.company = datum.name;
				point.companyTitle = datum.title;
				point.title = point.point_type_title
					? `${datum.title} - ${point.point_type_title.toLowerCase()}`
					: datum.title;
				point.image = datum.image;
				point.colorBrand = datum.colorBrand;
				point.markerActive = datum.markerActive;
				point.markerActive.size = point.markerActive.size || [69, 94];
				point.markerActive.offset = point.markerActive.offset || [-34.5, -94];
				point.marker = datum.marker;
				point.marker.size = point.marker.size || [50, 50];
				point.marker.offset = point.marker.offset || [-25, -25];
				points.push(point)
			})
		});

		return points.sort((a, b) => (a.distance_meters ?? Infinity) - (b.distance_meters ?? Infinity));
	}
}

export default Request;
